
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../../store';
import { Injectable } from '@angular/core';
import { OrderContext } from '../../models/order-context.state';

export const ORDER_CONTEXT = 'order/CONTEXT';



@Injectable()
export class OrderContextActions {


    constructor(private ngRedux: NgRedux<IAppState>) {

    }

    orderContext(orderState: OrderContext) {
        this.ngRedux.dispatch({
            type: ORDER_CONTEXT,
            orderState
        });
        return {
            type: ORDER_CONTEXT,
            orderState
        };
    }

}